export const PRICING = `${BACKOFFICE_API_URL}/products/:product/partners/:partnerId`
export const COMPANY_PRICING_ETR = `${BACKOFFICE_API_URL}/products/etr/companies/:id`
export const PARTNER_PRICING_ETR = `${BACKOFFICE_API_URL}/products/etr/partners/:id`
